// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import CaretDown from "@sc/XDL/Icons/CaretDown";
import { xBaseTheme } from "@sc/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        iconProps: {
            src: CaretDown,
            height: 13,
            width: 9,
            css: css`
                &&& {
                    background: transparent;
                }
            `,
        },
        css: css`
            &[aria-expanded="true"] ~ ${IconWrapper} {
                transform: rotate(180deg);
            }
            &:hover + ${IconWrapper} {
                svg {
                    color: ${getColor("common.ui8")};
                }
            }
        `,
        mergeCss: true,
    },
} as xBaseTheme["select"];
